// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  selectedRecordAccount: Object,
};

const DeleteAccount = (props: Props) => {
  const {
    visible,
    close,
    submit,
    selectedRecordAccount,
  } = props;

  const deleteAccount = () => {
    submit(selectedRecordAccount.gid);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={deleteAccount} type="danger">Delete</SpButton>,
      ]}
      title="Delete Account"
    >
      <div className="px-4">
        <div className="mt-1 mb-2">Are you sure you want to delete this Account ?</div>
        <SpH5 className="pb-3">
          <div>
            {selectedRecordAccount && selectedRecordAccount.issuerBank && (selectedRecordAccount.issuerBank.accountHolderName
              ? selectedRecordAccount.issuerBank.accountHolderName
              : (selectedRecordAccount.nickName ? selectedRecordAccount.nickName : <span>&#8211;</span>))}
          </div>
        </SpH5>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default DeleteAccount;
